var map = {
	"./gallery-wip-handle-cover_00.jpg": 2726,
	"./gallery-wip-handle-cover_01.jpg": 2727,
	"./gallery-wip-handle-cover_02.jpg": 2728,
	"./gallery-wip-handle-cover_03.jpg": 2729,
	"./gallery_00.jpg": 2730,
	"./gallery_01.jpg": 2731,
	"./gallery_02.jpg": 2732,
	"./gallery_03.jpg": 2733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2725;